
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getDeviceAuthDetail } from '../../../api/device';
import { UserModule } from '../../../store/modules/user';

@Component({
  name: 'DeviceDetail'

})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogDeviceDetailVisible!:Boolean;
  @Prop({
    type: Object,
    default: () => ({})
  })rowData!:any;
  created() {
    this.getDeviceAuthDetail();
  }
  private detail:any={
    auth: {}
  };
  private getDeviceAuthDetail() {
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.id = (this.rowData as any).device_id;
    getDeviceAuthDetail(params).then(res => {
      if (res.data) {
        this.detail = res.data;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private close() {
    this.$emit('close', false);
  }
}
